import { render, staticRenderFns } from "./SznshBank.vue?vue&type=template&id=6264d39c&scoped=true&"
import script from "./SznshBank.vue?vue&type=script&lang=js&"
export * from "./SznshBank.vue?vue&type=script&lang=js&"
import style0 from "./SznshBank.vue?vue&type=style&index=0&id=6264d39c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264d39c",
  null
  
)

export default component.exports